module.exports = __webpack_public_path__ + "static/mg-a5059bc9abe27a7465e855c5dd85c0e7.png";